import { render, staticRenderFns } from "./ReadySetGo.vue?vue&type=template&id=08390b63"
import script from "./ReadySetGo.vue?vue&type=script&lang=js"
export * from "./ReadySetGo.vue?vue&type=script&lang=js"
import style0 from "./ReadySetGo.vue?vue&type=style&index=0&id=08390b63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports